module.exports = __webpack_public_path__ + "media/images/company/cp09-b84bb4660b6f6970826118a43481d875.png";